<script setup>
defineProps({
  featured_text: {
    type: String,
    default: null,
  },
  featured_image: {
    type: Object,
    default: () => ({}),
  },
  featured_image_ratio: {
    type: String,
    default: null,
  },
  featured_button_text: {
    type: String,
    default: null,
  },
  featured_button_link: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<template>
  <div
    class="2xl:p-[60px] p-5 bg-[#AFA39D] grid 2xl:grid-cols-2 grid-cols-1 gap-[26px] items-center 2xl:w-[586px] w-[265px] flex-shrink-0 lg:max-w-full"
  >
    <Image
      v-if="featured_image?.filename && featured_image_ratio"
      :blok="{ ratio: featured_image_ratio, image: featured_image }"
    />
    <BlokImage v-else :blok="featured_image" />
    <div class="flex flex-col gap-4 justify-center">
      <div v-if="featured_text" class="text-xl font-helvetica-light">
        {{ featured_text }}
      </div>
      <BlokLink
        v-if="featured_button_text"
        class="flex gap-6 font-helvetica-bold"
        :blok="featured_button_link"
      >
        {{ featured_button_text }}
        <NuxtImg
          width="24px"
          height="24px"
          src="/icon/chevron-right-rounded.svg"
          alt="Chevron right"
        />
      </BlokLink>
    </div>
  </div>
</template>
